import flatMap from 'lodash/flatMap';

import { IFacet, IFacetGroup } from 'shared/models/facet';

export function findFacets(groups: IFacetGroup[] = [], facetIds: number[]): IFacet[] {
  return flatMap(groups, (group) => group.facets).filter((facet) => facetIds.includes(facet.id));
}

export function findFacetName(groups: IFacetGroup[] = [], facetId: number): string {
  return findFacets(groups, [facetId])[0]?.name ?? '';
}

export function findFacetNames(groups: IFacetGroup[], facetIds: number[] = []) {
  return findFacets(groups, facetIds).map((facet) => facet.name);
}

export function filterFacets(groups: IFacetGroup[], facetIds: number[]): IFacetGroup[] {
  return groups.reduce<IFacetGroup[]>((result, facetGroup) => {
    const filteredFacets: IFacet[] = facetGroup.facets.filter((facet) => facetIds.includes(facet.id));

    if (filteredFacets.length) {
      result.push({
        ...facetGroup,
        facets: filteredFacets,
      });
    }

    return result;
  }, []);
}

export function getJoinedFacetNames(groups: IFacetGroup[], facetIds: number[] = [], threshold?: number) {
  return findFacetNames(groups, facetIds).slice(0, threshold).join(', ');
}

export function getFacetIds(groups: IFacetGroup[]): number[] {
  return flatMap(groups, (group) => group.facets).map((facet) => facet.id);
}

export function containFacetIds(groups: IFacetGroup[], facetIds: number[]): boolean {
  const groupFacetIds = getFacetIds(groups);
  return facetIds.every((facetId) => groupFacetIds.includes(facetId));
}
